export const WATER = 'vanduo';
export const ELECTRICITY = 'elektra';
export const PAYMENT = 'mokestis';
export const LATE_INTEREST = 'delspinigiai';
